<template>
    <crud-base
      :url="url"
      :columns="columns"
      :onDelete="() => {}"
      :onUpdate="() => {}"
      :onStore="() => {}"
      :enableSearch="true"
      :checkAlerts="true"
      primaryKey="id"
    >
      <template v-slot:permite_ratear="{model}">
        <span :class="+model.permite_ratear ? 'badge badge-success' : 'badge badge-secondary'">
          {{ +model.permite_ratear ? 'Sim' : 'Não' }}
        </span>
      </template>
    </crud-base>

</template>

<script>
import CrudBase from "../../../components/crud/CrudBase";
export default {
  name: "TiposFrete",
  components: {
    CrudBase,
  },
  data() {
    return {
      url: "/admin/tipo-frete",
      columns: [
        { label: "ID", field: "id", sortable: false },
        { label: "DESCRIÇÃO", field: "descricao", sortable: false },
        { label: "ATIVO", field: "ativo", sortable: false },
        { label: "RATEIA FRETE", field: "permite_ratear", sortable: false }
      ],
    };
  },
};
</script>
